import React, { useState } from 'react';
import { Loader } from 'lucide-react';

/**
 * Click-to-edit dropdown cell for list/grid tables — lets a rep change a
 * common field (status, lifecycle stage, etc.) directly from the row instead
 * of opening the record's edit modal. Renders `badge` (the current read-only
 * view) until clicked, then swaps to a <select> that saves on change.
 */
export default function InlineEditSelect({ value, options, badge, onSave }) {
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);

  if (saving) {
    return <Loader size={14} className="animate-spin text-[#706E6B]" />;
  }

  if (!editing) {
    return (
      <span onClick={e => { e.stopPropagation(); setEditing(true); }} className="cursor-pointer inline-block" title="Click to edit">
        {badge}
      </span>
    );
  }

  return (
    <select
      autoFocus
      value={value}
      onClick={e => e.stopPropagation()}
      onBlur={() => setEditing(false)}
      onChange={async e => {
        const newValue = e.target.value;
        setEditing(false);
        if (newValue === value) return;
        setSaving(true);
        try {
          await onSave(newValue);
        } finally {
          setSaving(false);
        }
      }}
      className="h-7 px-1 border border-[#0176D3] rounded text-[11px] font-bold outline-none"
    >
      {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  );
}
